// extracted by mini-css-extract-plugin
module.exports = {"bannersTabsWrapper":"_1W4hGO-R4HkRq24hFx5TBG","tabsGroup":"_1mIl9w6jihcFy_PCqa9Pww"};